import { AllowListProp } from "./PropsFilterSelect";

const CSV_HEADER_ROW = [
  "Destination",
  "Destination ID",
  "Property Type",
  "Property",
  "Display Name",
];

export default function renderCSV(allowListProps: AllowListProp[]): string {
  const csvRows = allowListProps.map((prop) => {
    return [
      prop.destination,
      prop.destinationId,
      prop.type,
      prop.value,
      prop.displayName !== undefined ? prop.displayName : prop.value,
    ];
  });

  const rowsSorted = csvRows.sort((a, b) => {
    const dest = a[0].localeCompare(b[0]);
    const type = a[1].localeCompare(b[1]);
    const prop = a[2].localeCompare(b[2]);

    return dest + type + prop;
  });

  return [CSV_HEADER_ROW, ...rowsSorted].map((row) => row.join(",")).join("\n");
}
